<template>
    <div>
        <p v-if="getChangedStore1 && (ltype=='1')">{{readFromStore()}}</p>
        <p v-if="getChangedStore2 && (ltype=='2')">{{readFromStore()}}</p>
        <p v-if="getRefresh1 && (ltype=='1')">{{refreshData()}}</p>
        <p v-if="getRefresh2 && (ltype=='2')">{{refreshData()}}</p>
        
        <div>
            <v-text-field
                        label="Course name:"
                        v-model="mycontent.name"
            ></v-text-field>                          
            <v-text-field
                        label="Description:"
                        v-model="mycontent.description"
            ></v-text-field>     
            <v-flex xs12>
                <vue-editor :editor-toolbar="customToolbar" v-model='mycontent.detail'>
                </vue-editor>
            </v-flex>
            <v-flex xs12 justify-end>
                <v-btn @click="showHTML">Show HTML</v-btn>
                <v-btn v-if="showedHTML" @click="updateHTML">Update</v-btn>
            </v-flex>
                <v-textarea v-if="showedHTML" v-model=HTMLcontent>
            </v-textarea>                     
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {VueEditor} from 'vue2-editor'

export default {
    data() {
        return {
                customToolbar: [
                    [{ 'header': [false, 1, 2, 3,] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{'align': ''}, {'align': 'center'}, {'align': 'right'}],
                    ['code'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'indent': '-1'}, { 'indent': '+1' }],
                    [{ 'color': [] }, { 'background': [] }],
                    ['link', 'image','formula'],
                    ['clean'],
                ],
                showedHTML : false,
                HTMLcontent: '',
                mycontent:  {
                    name: 'loading...',
                    description: 'loading...',
                    detail: 'loading...'
                },
              }
    },
    components: {
        VueEditor: VueEditor
    },    
    props: ['ltype'],
    computed: 
            mapGetters([
                            'getLanguagePrimary',   
                            'getLanguageSecondary',
                            'getLanguagePrimaryTmp',   
                            'getLanguageSecondaryTmp',
                            'getRefresh1',
                            'getRefresh2',
                            'getChangedStore1',
                            'getChangedStore2',
                            'getContentUni'
                        ])
    ,
    methods: {
        showHTML() {
            this.showedHTML = !this.showedHTML
            this.HTMLcontent = this.mycontent.detail
        },
        updateHTML() {
            this.mycontent.detail = this.HTMLcontent
        },
        /************************************************************ */
        saveActualContent(mylang) {   
            var data = {
                lang_id : mylang.id,
                content: this.mycontent
            }
            this.$store.commit('setContentUni', data)            
        },

        refreshData() {
            // var lang = null
            if (this.ltype =='1') {
                this.$store.commit('setRefresh1',false)
                if (this.getLanguagePrimaryTmp) {
                    this.saveActualContent(this.getLanguagePrimaryTmp)
                }
                this.$store.commit('setChangedStore1',true)
            } else {
                this.$store.commit('setRefresh2',false)
                if (this.getLanguageSecondaryTmp)
                    this.saveActualContent(this.getLanguageSecondaryTmp)
                this.$store.commit('setChangedStore2',true)            
            }            
        },
        getContentUnifromStore(lang_id) {
            return this.getContentUni(lang_id)
        },

        readFromStore() {
            var con = -1
            if (this.ltype == 1) {
                this.$store.commit('setChangedStore1',false)
                con = this.getContentUnifromStore(this.getLanguagePrimary.id)
                this.mycontent = con
            }
            if (this.ltype == 2) {                
                this.$store.commit('setChangedStore2',false)
                con = this.getContentUnifromStore(this.getLanguageSecondary.id)
                this.mycontent = con
            }
        }
    } 

}
</script>


<style>

</style>

